<template>
  <div >
    <div class="p-10" v-if="showCode">
      <p class="mt-10 text-justify">{{asset.code}}</p>
    </div>
    <div class="text-center p-0 m-0">
      <i v-if="isVideo" class="el-icon-film fs-18"></i>
      <i v-if="isPicture" class="el-icon-picture fs-18"></i>
    </div>
    <div style="height:150px;" class="p-10 align-vertical-middle text-center">
      <cld-video v-if="isVideo" :publicId="asset.assetInfo.public_id">
        <cld-transformation width="150" crop="scale"/>
      </cld-video>
      <cld-image v-if="isPicture" :publicId="asset.assetInfo.public_id" secure=true>
        <cld-transformation width="150" height="150"crop="thumb" />
      </cld-image>
    </div>
    <div class="p-10" v-if="showDescription">
      <p class="mt-10 text-justify" v-html="asset.description[lang]"></p>
      <div class="flex justify-space-between o-050 fs-14">
        <div class="accent-text"><strong>{{_moment(asset.createdDate,'l')}}</strong></div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from 'moment-timezone'

export default {
	name: 'asset',
  props : {
    asset : {type : Object, required:true},
    showDescription : {type : Boolean, require:true},
    showCode : {type : Boolean, require:true}
  },
	data() {
		return {

		}
	},
  components : {

  },
  computed : {
    lang(){
      return this.$i18n.locale
    },
    isPicture(){
      return this.asset!=null && this.asset.assetInfo!=null && this.asset.assetInfo.video==null;
    },
    isVideo(){
      return this.asset!=null && this.asset.assetInfo!=null && this.asset.assetInfo.video!=null;
    }
  },
  methods : {

    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
		}
  },
  mounted(){


  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';



</style>
